<template>

    <div class="favorite_icon_container" @click="toggleStar">
        <i v-if="isFavorite" class="zmdi zmdi-star"></i>
        <i v-else class="zmdi zmdi-star-outline"></i>
    </div>

</template>

<script>
export default {
    name: 'FavoriteCheckbox',
    props: {
        isFavorite: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {}
    },
    methods: {
        toggleStar(){
            this.$emit("toggleFavorites", !this.isFavorite)
        }
    }
}


</script>

<style lang="scss">
.favorite_icon_container{
    cursor: pointer;
    i{
        font-size: 1.75rem;
        margin-top: -10px;
        display: block;
    }
    &:hover{
        color: $primary;
    }
    &.in_head{
        i{
            margin-top: 8px;
        }
    }

}
</style>